import { render, staticRenderFns } from "./courseList.vue?vue&type=template&id=4db243c1&scoped=true&"
import script from "./courseList.vue?vue&type=script&lang=js&"
export * from "./courseList.vue?vue&type=script&lang=js&"
import style0 from "./courseList.vue?vue&type=style&index=0&id=4db243c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db243c1",
  null
  
)

export default component.exports